import { Tag } from "@blueprintjs/core"
import { MouseEvent, useEffect, useState } from "react"
import { __ } from "src/libs/utilities"
import getURLToImageData from "src/libs/utilities/getURLToImage"
import getNewMeatTitle from "./utils/getNewMeatTitle"

/* Protopia Ecosystem component */
export interface IMeatCardProps {
   name: string
   i: number
   onClick: ( evt: MouseEvent, id: string, n: number ) => void
}
const MeatCard = (props: IMeatCardProps): JSX.Element => {
    const [ src, getSrc ] = useState<any>()
    useEffect(() => {
        const img = `/assets/img/landing/defaults/${ props.name }${ props.i }.jpg`
        getURLToImageData( img|| "" )
            .then(res => getSrc( res.src ))
            .catch( () => {
                getSrc( "https://i.pinimg.com/1200x/74/6e/d6/746ed6df07561f9b77c93d8bc8a1ceb6.jpg" )
            })

    }, [props.name, props.i])

    const getName = () : string | JSX.Element => {
        const t: string[] =  getNewMeatTitle(props.name, props.i)
        return <div>
            {__( t[0] )  } 
            <div className="small letter-spacing-1">
                { __( t[1] )}
            </div>
        </div>
    }
    return <div className=' landing-meat-card' onClick={(evt: MouseEvent) => props.onClick(evt, props.name, props.i )}>
        <img src={ src } alt="" />
        <div className="d-flex justify-content-between align-items-start mt-2 mb-1 ">
            <div className="letter-spacing-1 title">
                { getName() }
            </div>
            <div className="flex-grow-100 ml-2 d-flex justify-content-end">
                <Tag minimal className="micro text-light letter-spacing-1">+ CTRL</Tag>
            </div>
            
        </div>
    </div>
}
export default MeatCard

